export const en = {
    "k_ad17f965": "{arg_0}: ",
    "k_3ff655dc": "Expand change list",
    "k_35195a3c": "Change list",
    "k_d2f00ba6": "Collapse change list"
};
